import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useTaskResponsiblesData() {
    const { data: taskResponsibles, isPending: isTaskResponsiblesPending } = useQuery({
        queryKey: [QueryKey.DASHBOARD_TASKS_EMPLOYEES],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.dashboard.tasks.employees'));
            return data;
        },
        placeholderData: [],
    });

    return {
        taskResponsibles,
        isTaskResponsiblesPending,
    };
}
